import $ from 'jquery';

$(document).ready(()=>{

	const $trigger = $('[data-js-overlay="trigger"]');
	const $overlay = $('[data-js-overlay="overlay"]');
	const $close = $('[data-js-overlay="close"]');

	if($trigger.length){
		$close.on('click',closeOverlay);
		$trigger.on('click',showOverlay);
	}

	function showOverlay(e){
        e.preventDefault();

		$overlay.addClass('show');
	}

	function closeOverlay(){
		$overlay.removeClass('show');
	}
	
})